import { render, staticRenderFns } from "./IBSOutbound.vue?vue&type=template&id=abf80280&scoped=true"
import script from "./IBSOutbound.vue?vue&type=script&lang=js"
export * from "./IBSOutbound.vue?vue&type=script&lang=js"
import style0 from "./IBSOutbound.vue?vue&type=style&index=0&id=abf80280&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abf80280",
  null
  
)

export default component.exports